import { render, staticRenderFns } from "./PropiedadesTablaPopup.vue?vue&type=template&id=aeb83b3e"
import script from "./PropiedadesTablaPopup.vue?vue&type=script&lang=js"
export * from "./PropiedadesTablaPopup.vue?vue&type=script&lang=js"
import style0 from "./PropiedadesTablaPopup.vue?vue&type=style&index=0&id=aeb83b3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports